import React, { useState } from "react";

export type OAuth2LoginButtonProps = {
	provider: string;
};

const icons = {
	normal: "_signin_normal.png",
	pressed: "_signin_pressed.png"
};

const OAuth2LoginButton: React.FC<OAuth2LoginButtonProps> = (
	props: OAuth2LoginButtonProps
) => {
	const [pressed, setPressed] = useState(false);

	function getIcon(): string {
		return props.provider + (pressed ? icons.pressed : icons.normal);
	}

	return (
		<a
			href={"/api/oauth2/" + props.provider + "/login"}
			onMouseDown={(): void => setPressed(true)}
			onMouseLeave={(): void => setPressed(false)}
			onMouseUp={(): void => setPressed(false)}>
			<img
				id={props.provider + "-signin"}
				src={getIcon()}
				alt={"sign in with " + props.provider + " button"}></img>
		</a>
	);
};

export default OAuth2LoginButton;
